import ApiService from '@/services/api.service'

const PharmacyOptionService = {

    getAll() {          
        const requestData = {
            method: 'get',
            url: "/PharmacyOptions",
            headers: {
                
              },
            params: { 
               
            }
        }
        return ApiService.customRequest(requestData);
    },    

    getPharmacyOptions(){
        return ApiService.get(`/PharmacyOptions`);
    },
    
}
  
  export default PharmacyOptionService;